<template>
  <div class="ERP-configure">
    <div class="ERP-configure-main">
      <div class="configure-message">
        <div class="title" ref="steps">基础信息</div>
        <el-form
          ref="basicInformation"
          :model="basicInformation"
          :rules="rules"
          label-position="right"
          label-width="120px"
        >
          <div class="flex">
            <el-form-item label="客户ID：" prop="ID">
              <el-input v-model="basicInformation.ID" placeholder="请输入客户ID" class="gray"></el-input>
            </el-form-item>
            <el-form-item label="对接地址：" prop="link">
              <el-input v-model="basicInformation.link" placeholder="请输入对接地址" class="gray"></el-input>
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="对接Token：" prop="token">
              <el-input
                type="textarea"
                v-model="basicInformation.token"
                placeholder="请输入对接Token"
                class="gray"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否拆单推送：" prop="discountOrder">
              <div class="radio-container">
                <el-radio v-model="basicInformation.discountOrder" :label="1">开启</el-radio>
                <el-radio v-model="basicInformation.discountOrder" :label="0">关闭</el-radio>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="configure-message">
        <div class="title">默认信息</div>
        <el-form
          ref="defaultInformation"
          :model="defaultInformation"
          :rules="rules"
          label-position="right"
          label-width="120px"
        >
          <div class="flex">
            <el-form-item label="商品ID：" prop="goodsID">
              <el-input v-model="defaultInformation.goodsID" placeholder="请输入商品ID" class="gray"></el-input>
            </el-form-item>
            <el-form-item label="部门ID：" prop="departmentID">
              <el-input
                v-model="defaultInformation.departmentID"
                placeholder="请输入部门ID"
                class="gray"
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="优惠金额ID：" prop="discountAmountID">
              <el-input
                v-model="defaultInformation.discountAmountID"
                placeholder="请输入优惠金额ID"
                class="gray"
              ></el-input>
            </el-form-item>
            <el-form-item label="员工ID：" prop="staffID">
              <el-input v-model="defaultInformation.staffID" placeholder="请输入员工ID" class="gray"></el-input>
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="运费ID：" prop="freightID">
              <el-input v-model="defaultInformation.freightID" placeholder="请输入运费ID" class="gray"></el-input>
            </el-form-item>
            <el-form-item label="仓库ID：" prop="storehouseID">
              <el-input
                v-model="defaultInformation.storehouseID"
                placeholder="请输入仓库ID"
                class="gray"
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex" v-if="modulePoints">
            <el-form-item label="积分ID：" prop="integralID">
              <el-input v-model="defaultInformation.integralID" placeholder="请输入积分ID" class="gray"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div class="operations" ref="operations">
      <el-button class="btn-white" @click="cancel">取消</el-button>
      <el-button class="btn-blue" @click="submitInformation">保存</el-button>
    </div>
  </div>
</template>

<script>
import Apply from "models/db/apply";
const apply = new Apply();
import {
  getDBModuleStatusPermission,
} from "common/js/storage"; // 权限数据接口
export default {
  data() {
    return {
      basicInformation: {
        ID: "",
        link: "",
        token: "",
        discountOrder: 0
      },
      modulePoints: 0,
      defaultInformation: {
        goodsID: "",
        departmentID: "",
        discountAmountID: "",
        staffID: "",
        freightID: "",
        storehouseID: "",
        integralID: ""
      },
      rules: {
        ID: [{ required: true, message: "请输入客户ID", trigger: "blur" }],
        link: [{ required: true, message: "请输入对接地址", trigger: "blur" }],
        token: [
          { required: true, message: "请输入对接Token", trigger: "blur" }
        ],
        goodsID: [{ required: true, message: "请输入商品ID", trigger: "blur" }],
        departmentID: [
          { required: true, message: "请输入部门ID", trigger: "blur" }
        ],
        discountAmountID: [
          { required: true, message: "请输入优惠金额ID", trigger: "blur" }
        ],
        staffID: [{ required: true, message: "请输入员工ID", trigger: "blur" }],
        freightID: [
          { required: true, message: "请输入运费ID", trigger: "blur" }
        ],
        storehouseID: [
          { required: true, message: "请输入仓库ID", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.modulePoints = getDBModuleStatusPermission().modulePoints
    this.$emit("childMueu", "ERP对接/ERP配置");
    this.getInformation();
  },
  mounted() {
    const paddingWidth = 32;
    if (this.$refs.operations) {
      this.$refs.operations.style.width =
        this.$refs.steps.clientWidth + paddingWidth + "px";
      window.onresize = () => {
        this.$refs.operations.style.width =
          this.$refs.steps.clientWidth + paddingWidth + "px";
      };
    }
  },
  methods: {
    getInformation() {
      apply.getERPDetail().then(res => {
        console.log(res);
        if (res.success) {
          this.basicInformation.ID = res.result.key.c9DbId;
          this.basicInformation.link = res.result.key.c9Url;
          this.basicInformation.token = res.result.key.c9Token;
          this.basicInformation.discountOrder = res.result.key.splitOrderPush;
          this.defaultInformation.goodsID = res.result.key.c9DefaultGoodsId;
          this.defaultInformation.departmentID =
            res.result.key.c9DefaultDepartmentId;
          this.defaultInformation.discountAmountID =
            res.result.key.c9DefaultDiscountId;
          this.defaultInformation.staffID = res.result.key.c9DefaultEmployeeId;
          this.defaultInformation.freightID = res.result.key.c9DefaultFreightId;
          this.defaultInformation.storehouseID =
            res.result.key.c9DefaultWarehouseId;
          this.defaultInformation.integralID =
            res.result.key.c9DefaultPointsId;
        }
      });
    },
    submitInformation() {
      this.$refs["basicInformation"].validate(valid => {
        if (valid) {
          this.$refs["defaultInformation"].validate(valid => {
            if (valid) {
              let data = {};
              data.c9DbId = Number(this.basicInformation.ID);
              data.c9Url = this.basicInformation.link;
              data.c9Token = this.basicInformation.token;
              data.splitOrderPush = this.basicInformation.discountOrder
              data.c9DefaultGoodsId = Number(this.defaultInformation.goodsID);
              data.c9DefaultDepartmentId = Number(
                this.defaultInformation.departmentID
              );
              data.c9DefaultDiscountId = Number(
                this.defaultInformation.discountAmountID
              );
              data.c9DefaultEmployeeId = Number(
                this.defaultInformation.staffID
              );
              data.c9DefaultFreightId = Number(
                this.defaultInformation.freightID
              );
              data.c9DefaultWarehouseId = Number(
                this.defaultInformation.storehouseID
              );
              data.c9DefaultPointsId = Number(
                this.defaultInformation.integralID
              );
              apply.postERPStatus(data).then(res => {
                if (res.success) {
                  this.$message.success("配置成功");
                } else {
                  this.$message.error(res.message);
                }
              });
            } else {
              return false;
            }
          });
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang='scss' scoped>
.ERP-configure {
  padding: 32px;
  flex: 1;
  overflow: auto;
  .ERP-configure-main {
    background: #fff;
    min-height: 100%;
    padding: 16px;
    box-sizing: border-box;
    .configure-message {
      .title {
        height: 32px;
        background: rgba(245, 247, 250, 1);
        border-radius: 8px 8px 0px 0px;
        padding-left: 6px;
        font-size: 16px;
        line-height: 32px;
        margin-bottom: 20px;
      }
      .el-form {
        .flex {
          display: flex;
          .el-form-item {
            width: 440px;
            margin-right: 50px;
          }
        }
      }
    }
  }
  .operations {
    z-index: 300;
    height: 60px;
    position: fixed;
    left: 152px;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
    .el-button {
      width: 96px;
      letter-spacing: 4px;
    }
    .el-button + .el-button {
      margin-left: 24px;
    }
  }
}
</style>